<app-hour-control
    [realisations]="realisations()"
    [loadingData]="loadingData()"
    groupingType="planning_hourtype_material" />

<app-day-report-buttons
    [showActionButton]="true"
    (actionButtonClick)="add()"
    activePage="urenregistratie"
    actionButtonText="Toevoegen"
    actionButtonIcon="far fa-plus" />
